<template lang="html">
  <div class="">
    <AboutHero />
    <div>
      <TextInCenter>
        <template v-slot:text-center-body>
          <p>HappyG is an early-stage tech startup that empowers women by reimagining their overall medical experience with 21st century female healthcare solutions.</p>
          <p>We are a team of scientists, designers, and engineers determined to bring innovative ideas to life by combining our individual skills.</p>
          <div class="mt-5 mb-3">
            <h2 class="mt-3">Our Mission</h2>
            <h3><em>To help women, and those who love them, understand female health and find solutions.</em></h3>
          </div>
        </template>
      </TextInCenter>
    </div>
    <Values />
    <div class="mt-5 mb-5">
      <TextInCenter>
        <template v-slot:text-center-header>
          <span class="blue-text">We are in this together</span>
        </template>
        <template v-slot:text-center-body>
          <p class="pink-text">You and us, we’re on one team. You and us, we spend time together discussing, analyzing, testing, and improving. Our core philosophy comes from putting your interests first, and your help and support is what will turn our vision into a reality.</p>
          <p class="pink-text"> <b>So, thank you!</b> </p>
        </template>
      </TextInCenter>
    </div>

    <FooterTop />
  </div>
</template>

<script>
import FooterTop from '../components/footer/FooterTop'
import TextInCenter from '../components/utils/TextInCenter'
import AboutHero from '../components/aboutpage/AboutHero'
import Values from  '../components/aboutpage/Values'
export default {
  components: {
    FooterTop,
    TextInCenter,
    Values,
    AboutHero,
  },
}
</script>

<style lang="css" scoped>
</style>
